import React from "react";
import {Link} from "react-router-dom";
import {useSelector} from "react-redux";
import logo_white from "../../assets/icons/fort_logo/logo_white.png";
// import logo_no_background from "../../assets/icons/fort_logo/logo_no_background.jpg.jpg";
import logo_no_background from "../../assets/icons/fort_logo/logo-fort-no-background.png";
// import logo_white from "../../assets/icons/epislon/epsilon-logo-full-white.png";
// import logo_white from "../../assets/icons/nuvama_logo/nuvama_logo_no_background.png";

// import logo_no_background from "../../assets/icons/nuvama_logo/nuvama_logo_no_background.png";
// import logo_no_background from "../../assets/icons/epislon/epislon-money-black.png";
const Logo = ({handleClick, isDarkTheme}) => {
  const {isLoggedIn} = useSelector(state => state.auth);
  console.log(isDarkTheme);

  return (
    <Link
      onClick={handleClick}
      className="main-logo-container me-2"
      to={isLoggedIn ? "/dashboard" : "/"}
      style={{zIndex: 1}}
    >
      <img
        src={isDarkTheme ? logo_white : logo_no_background}
        alt="logo"
        className="logo"
      />
    </Link>
  );
};

export default Logo;
